import { FC } from 'react'
import { Alert, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { selectPracticeOverviewAlertType } from './practiceOverviewAlerts.selectors'

const PracticeOverviewAlert: FC = () => {
  const alertType = useReselector(selectPracticeOverviewAlertType)

  switch (alertType) {
    case 'CUBK_IN_PROGRESS':
      return (
        <Alert variant="warning" title="Catch-up bookkeeping in progress">
          <Text variant={TypographyStyles.BODY_MD}>
            This is a <strong>preview</strong> of your Practice Overview
            insights. Your data will be finalized after we complete your
            catch-up bookkeeping.
          </Text>
        </Alert>
      )

    default:
      return null
  }
}

export default PracticeOverviewAlert
